module.exports = __webpack_public_path__ + "img/ma-active.b3d1c965.png";